import React, { useState, useRef, useEffect } from 'react';

/**
 * Tooltip leve, instantâneo, com layout legível.
 * Uso:
 *   <Tooltip text="Texto longo do tooltip aqui">
 *     <span>?</span>
 *   </Tooltip>
 */
export default function Tooltip({ text, children, position = 'top', maxWidth = 260 }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Fecha quando clica fora (útil em mobile/tap)
  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const tooltipStyle = {
    position: 'absolute',
    [position === 'top' ? 'bottom' : 'top']: '125%',
    left: '50%',
    transform: 'translateX(-50%)',
    background: '#1F2937',
    color: '#fff',
    fontSize: 12,
    lineHeight: 1.5,
    padding: '8px 12px',
    borderRadius: 8,
    width: 'max-content',
    maxWidth,
    boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
    zIndex: 50,
    whiteSpace: 'normal',
    pointerEvents: 'none',
  };

  const arrowStyle = {
    position: 'absolute',
    [position === 'top' ? 'bottom' : 'top']: -4,
    left: '50%',
    transform: 'translateX(-50%) rotate(45deg)',
    width: 8,
    height: 8,
    background: '#1F2937',
  };

  return (
    <span
      ref={wrapperRef}
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
    >
      {children}
      {open && (
        <span style={tooltipStyle} role="tooltip">
          {text}
          <span style={arrowStyle} />
        </span>
      )}
    </span>
  );
}
